<template>
  <div class="transfer__wrapper transfer-payment-method" :class="{ 'is-checkout-fit': isCheckoutFit }">
    <!-- Оплата с баланса: если средств хватает, в додеп не ведём (как на супер-пассе) -->
    <form-layout
      v-if="currentStep === STEP.BALANCE"
      :main-title="$t('packs.title')"
      :mobile-title="$t('packs.titleMobile')"
      :small-title="true"
      :title="$t('packs.title')"
      :submit-text="$t('packs.payFromBalance')"
      :disabled="loading"
      @back="goBack"
      @submit="payFromBalance"
    >
      <div class="payments-step-2">
        <div class="payments-step-2__info">
          <div class="payments-step-2__infoPay">
            <Input :value="packAmountLabel" :disabled="true" icon="/base/robux.svg" placeholder="Робуксы" />
            <Input
              :value="pack.nickname"
              :disabled="true"
              icon="/base/user.svg"
              :placeholder="$t('transfer.nickname')"
            />
          </div>
          <Input :value="priceLabel" :disabled="true" :icon-text="currencySign" :placeholder="$t('packs.cost')" />
        </div>

        <p class="payments-step-2__result">
          {{ $t('payment.toPay') }}:
          <span>{{ priceLabel }}</span>
        </p>
      </div>
    </form-layout>

    <!-- Шаг 1: Выбор метода оплаты (1-в-1 как на гифт-картах) -->
    <form-layout
      v-if="currentStep === STEP.METHODS"
      :main-title="$t('packs.title')"
      :mobile-title="$t('packs.titleMobile')"
      :small-title="true"
      submit-text="Далее"
      @back="goBack"
      @submit="goToNextStep"
    >
      <div class="payments-content__body">
        <Loader v-if="loading" />
        <div class="payments-content__body__header">
          <div class="payments-content__body__header__left">
            <div class="payments-content__body__header__image">
              <img src="@/assets/images/payments/payments-ico.svg" alt="ico" />
            </div>
            <span>{{ $t('payment.selectPaymentMethod') }}</span>
          </div>
        </div>
        <PaymentMethodsList :current="selectedMethodName" :list="methodsInCustomOrder" @select="choosePaymentMethod" />
      </div>

      <div class="payments-content__info">
        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.replenishmentAmount') }}</div>
          <Input
            v-model.trim="amount"
            type="number"
            :icon-text="currencySign"
            :placeholder="$t('payment.enterSum')"
            :disabled="true"
          />
        </div>

        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.commission') }}:</div>
          <Input
            v-model.trim="commissionValue"
            icon-text="%"
            :placeholder="$t('payment.commission')"
            :disabled="true"
          />
        </div>
      </div>
    </form-layout>

    <!-- Шаг 2: Чекаут (подтверждение оплаты) -->
    <form-layout
      v-if="currentStep === STEP.CHECKOUT"
      :main-title="$t('packs.title')"
      :small-title="true"
      :title="$t('packs.title')"
      :submit-text="$t('payment.pay')"
      :disabled="loading"
      @back="currentStep = STEP.METHODS"
      @submit="createOrder"
    >
      <div class="payments-step-2">
        <div class="payments-step-2__info">
          <div class="payments-step-2__method">
            <Input :value="paymentMethodName" :disabled="true" icon="/base/payment.svg" placeholder="Метод оплаты" />
            <span class="payments-step-2__method-commission">
              Комиссия {{ $store.state.paymentsOrder.selectedMethod.commission }}%
            </span>
          </div>

          <div class="payments-step-2__infoPay">
            <Input :value="packAmountLabel" :disabled="true" icon="/base/robux.svg" placeholder="Робуксы" />
            <Input
              :value="pack.nickname"
              :disabled="true"
              icon="/base/user.svg"
              :placeholder="$t('transfer.nickname')"
            />
          </div>
          <Input
            :value="amount + ' ' + currencySign"
            :disabled="true"
            :icon-text="currencySign"
            :placeholder="$t('payment.replenishmentAmount')"
          />
        </div>

        <p class="payments-step-2__result">
          {{ $t('payment.toPay') }}:
          <span>{{ commissionValue }} {{ currencySign }}</span>
        </p>
      </div>
    </form-layout>
  </div>
</template>

<script>
import paymentsMethodsInfo from '@/constants/paymentsMethodsInfo'
import { getCommissionNewLava } from '@/utils/formatting'
import { getPaymentMethodName, makePayment } from '@/utils/paymentMethods'
import { mapGetters } from 'vuex'
import Loader from '@/components/LoaderBar/LoaderBar'
import Input from '@/components/Base/Input/Input.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PaymentMethodsList from '@/components/PaymentMethodsList/PaymentMethodsList.vue'
import { METHODS_ORDER } from '@/constants/paymentMethods'
import { getPackOrderErrorKey, makePackOrder, PACK_CATEGORY } from '@/utils/packsApi'
import paymentSubStep from '@/mixins/paymentSubStep'

// Поставщик паков работает только в рублях: цена товара приходит одним числом
// в ₽, баланс списывается в ₽ — поэтому и оплата всегда идёт в ₽, независимо
// от выбранной на сайте валюты.
const PACKS_CURRENCY = 'RUB'

// Средств на балансе хватает — платим с него (BALANCE) и додеп не показываем.
// Не хватает — обычные два шага пополнения, как на гифтах.
const STEP = {
  BALANCE: 0,
  METHODS: 1,
  CHECKOUT: 2
}

// Код ошибки make_logpass_order: недостаточно средств на балансе.
const ERROR_NOT_ENOUGH_FUNDS = 4

export default {
  name: 'PacksPayment',
  components: {
    PaymentMethodsList,
    FormLayout,
    Input,
    Loader
  },
  inject: ['currencyMap'],
  mixins: [paymentSubStep],
  props: {
    // pack: выбранный пак + nickname (проброшены из Transfer.vue)
    pack: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentStep: STEP.METHODS,
      selectedMethod: {
        name: '',
        currency: '',
        commission: 0,
        email: null,
        method: null,
        key: null
      },
      paymentMethod: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToGatewayMap)),
      paymentSystemsMap: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToSystemMap)),
      methodMaps: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsConfig)),
      allMethods: JSON.parse(JSON.stringify(paymentsMethodsInfo.allMethods)),
      filters: { country: 'RU', currency: 'RUB' },
      currencyRate: { RUB: 1, USD: 73, EUR: 80, EURUSD: 1, USDEUR: 1 },
      amount: null,
      loading: false,
      newCommissions: []
    }
  },
  created() {
    this.getNewCommission()
    this.amount = this.price
    this.currentStep = this.canPayFromBalance ? STEP.BALANCE : STEP.METHODS
  },
  mounted() {
    this.setUserRegion()
  },
  computed: {
    ...mapGetters(['language', 'country']),
    STEP: () => STEP,
    // Поджимаем карточку под контент только на чекауте. Шаг оплаты с баланса
    // тянется на всю высоту — как остальные шаги других методов.
    isCheckoutFit() {
      return this.currentStep === STEP.CHECKOUT
    },
    // Валюта оплаты паков фиксирована (см. PACKS_CURRENCY).
    currency() {
      return PACKS_CURRENCY
    },
    currencySign() {
      return this.currencyMap[PACKS_CURRENCY.toLowerCase()]
    },
    balance() {
      const balance = this.$store.state.account.balance || {}

      return Number(balance[PACKS_CURRENCY.toLowerCase()]) || 0
    },
    price() {
      return this.pack.price?.[PACKS_CURRENCY.toLowerCase()] || 0
    },
    priceLabel() {
      return `${this.price} ${this.currencySign}`
    },
    balanceLabel() {
      return `${this.balance.toFixed(2)} ${this.currencySign}`
    },
    canPayFromBalance() {
      return this.balance >= this.price && this.price > 0
    },
    packAmountLabel() {
      // для premium показываем название, для robux — количество R$
      return this.pack.category === PACK_CATEGORY.PREMIUM ? this.pack.name : `${this.pack.quantity} R$`
    },
    paymentMethodName() {
      return getPaymentMethodName(this.selectedMethod.name)
    },
    selectedCountry() {
      return this.filters.country
    },
    filteredMethods() {
      const sortByPriority = (a, b) => {
        return this.methodMaps[a.key]?.priority[this.selectedCountry] >
          this.methodMaps[b.key]?.priority[this.selectedCountry]
          ? 1
          : -1
      }
      const filteredMethods = this.allMethods.map(m => ({
        key: m,
        currency: this.filters.currency,
        commission: this.getMethodCommission(m),
        iconType: this.methodMaps[m].iconType,
        iconName: this.methodMaps[m].iconName,
        min: this.methodMaps[m]?.min?.default
      }))
      return filteredMethods
        .sort((a, b) => sortByPriority(a, b))
        .filter((item, index, self) => index === self.findIndex(obj => obj.key === item.key))
    },
    commissionValue() {
      if (!this.selectedMethod.name || !this.amount) return ''
      const method = this.selectedMethod.name
      if (this.shouldReturnUnknown(method)) return 'Unknown'
      if (this.isQiwiMethod(method)) return this.calculateQiwiCommission()
      const commission = this.calculateCommissionRate(method)
      const amount = Number(this.amount)
      const multipliedResult = this.calculateWithMultipliers(method, amount, commission)
      if (multipliedResult !== null) return multipliedResult
      if (this.paymentSystemsMap[method] === 'gm') {
        const fixFee = this.methodMaps[method]?.fix?.[this.currency] || 0
        return this.getPrice(amount, commission, fixFee).toFixed(2)
      }
      if (this.paymentSystemsMap[method] === 'gram') {
        return this.calculateGramCommission(amount)
      }
      return this.getPrice(amount, commission, 0, this.shouldUseLavaCalculation(method))
    },
    methodsInCustomOrder() {
      const methods = [...this.newCommissions, ...this.filteredMethods]
      const orderedMethods = this.getMethodsWithOrder(methods)
      return orderedMethods.length ? orderedMethods : methods
    },
    selectedMethodName() {
      return this.selectedMethod.method || this.selectedMethod.key
    }
  },
  watch: {
    'selectedMethod.name': function(val) {
      if (val) {
        const minVar = this.methodMaps[val].min
        const minVal = typeof minVar === 'object' ? minVar[this.currency.toUpperCase()] : minVar
        this.amount = this.price >= minVal ? this.price : this.ceil(minVal, 2)
      }
    },
    // Баланс мог догрузиться после монтирования (authorization асинхронный) —
    // не держим пользователя в додепе, если платить есть чем.
    canPayFromBalance(value) {
      if (value && this.currentStep === STEP.METHODS && !this.selectedMethod.name) {
        this.currentStep = STEP.BALANCE
      }
    }
  },
  methods: {
    getCommissionNewLava,
    goBack() {
      this.$emit('changeModal', { modal: 'TransferCharacters' })
    },
    notifyError(description) {
      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.warning'),
        description,
        type: 'error'
      })
    },
    notifyOrderError(order) {
      this.notifyError(order?.message || this.$t(getPackOrderErrorKey(order)))
    },
    // Создание заказа: креды аккаунта спрашиваем уже ПОСЛЕ оплаты, в модалке
    // выдачи на странице истории (update_logpass_order).
    createPackOrder(flag) {
      return makePackOrder({
        productId: this.pack.id,
        username: this.pack.nickname,
        flag,
        token: this.$cookies.get('access_token')
      })
    },
    // --- Оплата с баланса (заказ сразу в статусе paid) ---
    async payFromBalance() {
      this.loading = true
      try {
        const order = await this.createPackOrder(false)
        const orderId = order.order_id

        if (!order.status || !orderId) {
          this.notifyOrderError(order)
          // Баланса всё-таки не хватило (например, списание в другой вкладке) —
          // уводим на пополнение, чтобы шаг оплаты не стал тупиком.
          if (order.data?.includes(ERROR_NOT_ENOUGH_FUNDS)) this.currentStep = STEP.METHODS
          return
        }

        this.$analytics.send('purch_packs_3_payment_balance', {})
        // Баланс уже списан на бэке — подтягиваем актуальный.
        this.$store.dispatch('authorization', this.$cookies.get('access_token'))
        this.$router.push({ name: 'History', query: { method: 'packs', order: orderId } })
      } catch (e) {
        this.notifyError(this.$t('payment.errors.server'))
      } finally {
        this.loading = false
      }
    },
    goToNextStep() {
      if (!this.selectedMethod.name) {
        this.notifyError(this.$t('payment.errors.empty'))
        return
      }
      this.$store.commit('paymentsOrder/setAmount', Number(this.amount))
      this.$store.commit('paymentsOrder/setCurrency', this.currency)
      this.$store.commit('paymentsOrder/setSelectedMethod', {
        name: this.selectedMethod.name,
        key: this.selectedMethod.key,
        commission: this.selectedMethod.commission,
        iconType: this.selectedMethod.iconType,
        iconName: this.selectedMethod.iconName
      })
      this.$store.commit('paymentsOrder/setCommission', this.commissionValue)
      this.$store.commit('paymentsOrder/setTotalToPay', this.commissionValue)
      this.currentStep = STEP.CHECKOUT
    },
    // --- Оплата платёжкой (додеп) ---
    // Заказ создаётся в статусе new, в paid его переведёт бэк по колбэку
    // платёжки — после этого он появится в истории с «Необходимо действие».
    async createOrder() {
      if (!this.selectedMethod.name) return
      this.loading = true
      try {
        const order = await this.createPackOrder(true)
        const orderId = order.order_id
        const userId = this.$store.state.account.userId

        if (!order.status || !orderId) {
          this.notifyOrderError(order)
          return
        }

        if (!userId) {
          this.notifyError(this.$t('payment.errors.server'))
          return
        }

        this.$analytics.send('purch_packs_3_payment_credits', {})

        const paymentResult = await makePayment(
          { name: this.selectedMethod.name, key: this.selectedMethod.key, method: this.selectedMethod.method },
          orderId,
          userId,
          Number(this.amount),
          null,
          this.currency
        )

        if (paymentResult?.redirect_uri) {
          this.$analytics.send('topup', { topup_id: paymentResult.id || orderId, source: 'packs' })
          location.href = paymentResult.redirect_uri
        } else {
          this.$analytics.send('topup_error', { source: 'packs' })
          this.notifyError(this.$t('payment.errors.server'))
        }
      } catch (e) {
        this.$analytics.send('topup_error', { source: 'packs' })
        this.notifyError(this.$t('payment.errors.server'))
      } finally {
        this.loading = false
      }
    },
    setUserRegion() {
      const EU_COUNTRIES = [
        'AU',
        'BE',
        'BG',
        'GB',
        'HU',
        'DE',
        'GR',
        'DK',
        'IE',
        'ES',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'LI',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'FI',
        'FR',
        'HR',
        'CZ',
        'SE',
        'EE',
        'BA',
        'IS',
        'NO'
      ]
      const RU_COUNTRIES = ['AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'TM', 'GE']
      const SELECTED_COUNTRIES = ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR']
      if (EU_COUNTRIES.includes(this.country)) this.filters.country = 'EU'
      else if (RU_COUNTRIES.includes(this.country)) this.filters.country = 'RU'
      else if (SELECTED_COUNTRIES.includes(this.country)) this.filters.country = this.country
      else this.filters.country = 'RU'
    },
    ceil(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    getMethodCommission(method) {
      if (typeof this.methodMaps[method].commission === 'object') {
        const key = Object.keys(this.methodMaps[method].commission)
        if (key.includes(this.filters.country)) return this.methodMaps[method].commission[this.filters.country]
        return this.methodMaps[method].commission.default
      }
      return this.methodMaps[method].commission
    },
    choosePaymentMethod(method) {
      this.selectedMethod.name = method.key
      this.selectedMethod.key = method.key
      this.selectedMethod.method = method.key
      this.selectedMethod.currency = method.currency
      this.selectedMethod.commission = method.commission
      this.selectedMethod.iconType = method.iconType
      this.selectedMethod.min = method.min
      this.selectedMethod.email = method.email
      this.selectedMethod.iconName = method.iconName
    },
    async getNewCommission() {
      try {
        const response = await fetch('https://payments.backend-pier.com/api/v1/topups/lava_commissions')
        const data = await response.json()
        const { commissions } = data
        this.newCommissions = commissions
          ?.filter(item => item.status)
          .map(item => ({ ...item, name: 'lava', key: 'lava_' + item.method }))
      } catch (error) {
        console.error('Error fetching commissions:', error)
      }
    },
    getMethodsWithOrder(currentList) {
      const filteredList = []
      METHODS_ORDER.forEach(methodName => {
        const method = currentList.find(item => item.key === methodName)
        if (method) filteredList.push(method)
      })
      return filteredList
    },
    shouldReturnUnknown(method) {
      return ['new_fk', 'payok'].includes(method)
    },
    isQiwiMethod(method) {
      return method === 'qiwi'
    },
    calculateQiwiCommission() {
      const commission = this.methodMaps.qiwi.commission
      return Math.ceil((Number(this.amount) + (this.amount * commission) / 100) * 100) / 100
    },
    calculateCommissionRate(method) {
      const methodCommission = this.methodMaps[method]?.commission
      if (typeof methodCommission !== 'object') return methodCommission
      return methodCommission[this.filters.country] || methodCommission.default
    },
    getPrice(amount, commission, multiplier = 0, useLavaFormula = false) {
      if (useLavaFormula) return Number((amount / (1 - commission / 100)).toFixed(2))
      return Number((amount + (amount * commission) / 100 + multiplier).toFixed(2))
    },
    shouldUseLavaCalculation(method) {
      return ['cardlink', 'cardlink_sbp', 'cardlink_copy', 'lava'].includes(method)
    },
    calculateWithMultipliers(method, amount, commission) {
      const multipliers = {
        redpagos: { RUB: 0.5 * this.currencyRate.USD, EUR: 0.5 * this.currencyRate.USDEUR, USD: 0.5 },
        servipag: { RUB: 1.5 * this.currencyRate.USD, EUR: 1.5 * this.currencyRate.USDEUR, USD: 1.5 },
        boleto: { RUB: this.currencyRate.USD, EUR: this.currencyRate.USDEUR, USD: 1 }
      }
      if (multipliers[method] && multipliers[method][this.currency]) {
        return this.getPrice(amount, commission, multipliers[method][this.currency])
      }
      if (method === 'card_gm') return this.calculateCardGmCommission(amount, commission)
      return null
    },
    calculateCardGmCommission(amount, commission) {
      const cardGmMultipliers = {
        EU: { RUB: 0.1 * this.currencyRate.EUR, EUR: 0.1, USD: 0.1 * this.currencyRate.EURUSD },
        default: { RUB: 0.12 * this.currencyRate.EUR, EUR: 0.12, USD: 0.12 * this.currencyRate.EURUSD }
      }
      const multiplierConfig = ['RU', 'UA', 'EU'].includes(this.filters.country)
        ? cardGmMultipliers.EU
        : cardGmMultipliers.default
      if (multiplierConfig[this.currency]) return this.getPrice(amount, commission, multiplierConfig[this.currency])
      return null
    },
    calculateGramCommission(amount) {
      const c = Number(amount / 7).toFixed(2)
      const minCommission = 4.9 / this.currencyRate[this.currency]
      if (c > minCommission) return Math.ceil((amount + Number(c)) * 100) / 100
      return Math.ceil((amount + minCommission) * 100) / 100
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../Transfer/transferPaymentMethod/transferPaymentMethod.scss';

// Без Alert-блока контента меньше — не растягиваем на всю высоту (иначе
// «К оплате» улетает вниз и получается большой пустой отступ).
// Селектор в 2 класса — чтобы перебить базовое `.transfer-payment-method .payments-step-2`.
.transfer-payment-method .payments-step-2 {
  flex: 1;
  height: auto;
  justify-content: space-between;
  gap: 16px;
}

// На десктопе робуксы и ник идут в строку (ок). На мобилке базовый стиль
// делает их столбиком с gap:0 — возвращаем отступ между ними.
@media screen and (max-width: 743px) {
  .transfer-payment-method .payments-step-2__infoPay {
    gap: 12px;
  }
}

// На шаге чекаута контента мало — карточка подгоняется под контент,
// иначе фикс. высота (560/483px) даёт пустой отступ и обрезает верх.
.transfer-payment-method.is-checkout-fit ::v-deep .form-layout {
  height: auto;
  max-height: none;
}

.packs-payment {
  &__balance-hint {
    font-size: 13px;
    color: #8a8a8a;
    text-align: center;
  }
}
</style>
